import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class AppointmentService {
  public hasShift = true;

  emitHasShift(hasShit: boolean) {
    this.hasShift = hasShit;
  }

  constructor() { }
}
